import React from 'react';

import { SortingDirection } from './constants';
import Icon from '../Icon';

interface DirectionIndicatorProps {
  direction: SortingDirection;
}

export const DirectionIndicator: React.FC<DirectionIndicatorProps> = ({
  direction,
}) =>
  ({
    [SortingDirection.ASC]: (
      <Icon name="sorting" className="up" size="x-small" />
    ),
    [SortingDirection.DESC]: (
      <Icon name="sorting" className="down" size="x-small" />
    ),
    [SortingDirection.NONE]: (
      <Icon name="sorting" className="up-down" size="x-small" />
    ),
  }[direction]);
